// mds-dojo — dijit/ConfirmDialog — FAITHFUL port of references/dijit/ConfirmDialog.js.
// A Dialog with OK/Cancel buttons. AMD → ESM + declare from the faithful runtime.
import declare from '../dojo/_base/declare-runtime';
import Dialog from './Dialog';
import _ConfirmDialogMixin from './_ConfirmDialogMixin';

export default declare('dijit.ConfirmDialog', [Dialog, _ConfirmDialogMixin], {
  // summary:
  //		A Dialog with OK/Cancel buttons.
});
